/**
 * Core Spacing Tokens — Tier 1
 *
 * Raw spacing scale. Values are in pixels. Mirrors Figma variables exactly — do not alter.
 * JS key maps to Figma token: spacing[1] → spacing-1, spacing[4] → spacing-4.
 *
 * Scale: keys 1–6 are consecutive 4px steps (4, 8, 12, 16, 20, 24).
 * Keys 7–13 jump intentionally (32, 40, 48, 64, 80, 96, 180) — designer-defined, Figma-locked.
 *
 * MUI usage: theme.spacing(N) = 4px × N.
 * Keys above 6 are NOT simple multiples of 4 — always pass the token key to theme.spacing(N),
 * never compute the pixel value yourself. Read this file for the full key→px mapping.
 *
 * Rules:
 * - Tier 2 semantic tokens reference these keys; never raw values
 * - Do not add values outside this scale without designer sign-off
 */

export const spacing = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  7: 32,
  8: 40,
  9: 48,
  10: 64,
  11: 80,
  12: 96,
  13: 180,
} as const;

export type Spacing = typeof spacing;
export type SpacingToken = keyof Spacing;
